import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import validatePhone from '../utils/validatePhone';

export default class ShareContactModal extends Modal {
  senderPhone = Stream('');
  message = Stream('');
  phoneError = '';
  formError: string | null = null;

  oninit(vnode) {
    super.oninit(vnode);

    const sender = app.session.user;
    this.senderPhone = Stream(sender.attribute('phoneNumber') || '');
    this.message = Stream('');
    this.phoneError = '';
    this.formError = null;
  }

  onready() {
    this.$('input:not([readonly]), textarea').first().trigger('focus');
  }

  className() {
    return 'Modal--medium ShareContactModal';
  }

  title() {
    return app.translator.trans('gcs-share-contact.forum.modal.title', {
      recipient: this.attrs.recipient.displayName(),
    });
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <div className="Form-group">
            <label>{app.translator.trans('gcs-share-contact.forum.modal.email_label')}</label>
            <input
              className="FormControl FormControl--readonly"
              type="email"
              value={app.session.user.email()}
              readonly
              tabindex="-1"
            />
          </div>

          <div className="Form-group">
            <label>{app.translator.trans('gcs-share-contact.forum.modal.phone_label')}</label>
            <input
              className={'FormControl' + (this.phoneError ? ' GcsInput--error' : '')}
              type="tel"
              value={this.senderPhone()}
              oninput={(e) => {
                this.senderPhone(e.target.value);
                this.phoneError = validatePhone(e.target.value)
                  ? ''
                  : app.translator.trans('gcs-share-contact.forum.settings.phone_invalid');
              }}
            />
            {this.phoneError && (
              <p className="GcsShareContact-error">{this.phoneError}</p>
            )}
          </div>

          <div className="Form-group">
            <label>{app.translator.trans('gcs-share-contact.forum.modal.message_label')}</label>
            <textarea
              className="FormControl"
              rows={4}
              value={this.message()}
              oninput={(e) => this.message(e.target.value)}
            />
          </div>

          {this.formError && (
            <div className="Form-group">
              <p className="GcsShareContact-error">{this.formError}</p>
            </div>
          )}

          <div className="Form-group">
            <Button
              className="Button Button--primary"
              type="submit"
              loading={this.loading}
              disabled={!!this.phoneError}
              onclick={this.onsubmit.bind(this)}
            >
              {app.translator.trans('gcs-share-contact.forum.modal.submit_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    if (!validatePhone(this.senderPhone())) {
      this.phoneError = app.translator.trans('gcs-share-contact.forum.settings.phone_invalid');
      m.redraw();
      return;
    }

    this.loading = true;
    this.formError = null;

    app
      .request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/share-contact`,
        body: {
          data: {
            attributes: {
              recipientId: this.attrs.recipient.id(),
              senderPhone: this.senderPhone(),
              message: this.message(),
            },
          },
        },
      })
      .then(() => {
        app.modal.close();
        app.alerts.show({ type: 'success' }, app.translator.trans('gcs-share-contact.forum.modal.success'));
      })
      .catch((e) => {
        this.loading = false;

        if (e?.status === 422 && e?.response?.errors?.length) {
          this.formError = e.response.errors[0].detail;
          m.redraw();
        } else {
          m.redraw();
          throw e;
        }
      });
  }
}
